import React, { useEffect, useState } from "react";
import ROUTE_PATH from "../../constant/route";
import { useNavigate } from "react-router-dom";
import BackArrow from "../../assets/svg/back-arrow.svg";

const TermsMobile = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const navigate = useNavigate();
  useEffect(() => {
    // Function to update window width
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    // Add event listener to update width on window resize
    window.addEventListener("resize", handleResize);

    // Cleanup function to remove event listener
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);


  useEffect(() => {
    if (windowWidth > 600) {
      navigate(ROUTE_PATH.WELLNESS);
    }
  }, [windowWidth]);
  return (
    <div className="py-[30px] px-[16px]">
      <div className="flex items-center w-[100%] text-[16px] leading-[20px] font-semibold">
        <img
          src={BackArrow}
          alt="BackArrow"
          className="block lg:hidden relative left-[-5%]"
          onClick={() => navigate(ROUTE_PATH.DASHBOARD)}
        />
        <span className="relative top-[-5px] left-[-5%]">
          Terms and Conditions
        </span>
      </div>
      <div>
        <div className="text-[12px] leading-[16px] text-text-color-3 pt-[12px]">
          Welcome to coversure prosure. Please read these Terms and Conditions
          carefully before using our services. By accessing or using our
          website, mobile application, or services, you agree to comply with and
          be bound by the following terms.
        </div>
        <div className="w-[100%] text-[16px] leading-[16px] font-semibold mt-[30px] mb-[10px]">
          1. General Terms
        </div>
        <div className="text-[12px] leading-[16px] text-text-color-3">
          Welcome to coversure prosure. Please read these Terms and Conditions
          carefully before using our services. By accessing or using our
          website, mobile application, or services, you agree to comply with and
          be bound by the following terms.
        </div>
        <div className="w-[100%] text-[16px] leading-[16px] font-semibold mt-[20px] mb-[10px]">
          2. Eligibility
        </div>
        <div className="text-[12px] leading-[16px] text-text-color-3">
          Welcome to coversure prosure. Please read these Terms and Conditions
          carefully before using our services. By accessing or using our
          website, mobile application, or services, you agree to comply with and
          be bound by the following terms.
        </div>
        <div className="w-[100%] text-[16px] leading-[16px] font-semibold mt-[20px] mb-[10px]">
          3. Policy Terms
        </div>
        <div className="text-[12px] leading-[16px] text-text-color-3">
          3.1 The specific terms of your insurance policy, including coverage,
          premium, and exclusions, will be detailed in your policy document.
          These terms will take precedence over any general descriptions on our
          website or promotional materials.
        </div>
        <br />
        <div className="text-[12px] leading-[16px] text-text-color-3">
          3.2 It is your responsibility to review and understand your policy
          document. If you have any questions, please contact our support team.
        </div>
        <div className="w-[100%] text-[16px] leading-[16px] font-semibold mt-[20px] mb-[10px]">
          4. Premium Payments
        </div>
        <div className="text-[12px] leading-[16px] text-text-color-3">
          4.1 Premiums must be paid in full by the due date specified in your
          policy. Failure to pay premiums on time may result in policy
          cancellation.
        </div>
      </div>
    </div>
  );
};

export default TermsMobile;
